import assert from './assert'

export const sourcePath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/overview`
}

export const warehouseSimulatorPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/warehouse-simulator`
}

export const sourceRunPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug', 'runId'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/overview/runs/${
    args.runId
  }`
}

export const sourceSetupPath = args => {
  assert(args, ['workspaceSlug', 'sourceMetadataSlug'])
  return `/${args.workspaceSlug}/sources/setup/${args.sourceMetadataSlug}`
}

export const sourceSettingsPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/basic`
}

export const sourceSettingsSqlPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/sql`
}

export const sourceSettingsOAuthPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/oauth`
}

export const sourceSettingsCollaboratorsPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${
    args.sourceSlug
  }/settings/collaborators`
}

export const sourceSettingsConnectionPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/connection`
}

export const sourceSettingsMovePath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/move`
}

export const sourceSettingsWebhookPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/endpoint`
}

export const sourceSettingsSchemaPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/schema`
}

export const sourceSettingsKeysPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/keys`
}

export const sourceSettingsCrossDomainAnalyticsPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${
    args.sourceSlug
  }/settings/cross-domain-analytics`
}

export const sourceSettingsSelectiveSyncPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${
    args.sourceSlug
  }/settings/selective-sync`
}

export const sourceDebuggerPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/debugger`
}

export const sourcesPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/sources`
}

export const sourcesCatalogPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/sources/catalog`
}

export const sourcesCatalogItemPath = args => {
  assert(args, ['workspaceSlug', 'sourceMetadataSlug'])
  const { workspaceSlug, sourceMetadataSlug, category } = args
  let basePath = `/${workspaceSlug}/sources/catalog/${sourceMetadataSlug}`
  if (category) {
    basePath = basePath.concat(`?category=${category}`)
  }
  return basePath
}
